import { render } from "./ThemeTab.vue?vue&type=template&id=6f0fc4fa&scoped=true&lang=pug"
import script from "./ThemeTab.js?vue&type=script&lang=js&external"
export * from "./ThemeTab.js?vue&type=script&lang=js&external"

import "./ThemeTab.vue?vue&type=style&index=0&id=6f0fc4fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0fc4fa"]])

export default __exports__